import i18n from '@/i18n/index.js'

export const localizedRouteName = routeName => {
    return i18n.global.locale.value === i18n.global.fallbackLocale.value
        ? routeName
        : `${routeName}:${i18n.global.locale.value}`
}
